(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration');
    module.controller('ProtocolOverviewController', ['$filter', '$scope', '$sce', '$state', '$uibModal', 'Protocol', 'ProtocolService', 'SharedAgendaService', 'PaginationService', 'SharedAgendaBroadcast', ProtocolOverviewControllerFn]);

    /* controller for protocol-settings overview */
    function ProtocolOverviewControllerFn($filter, $scope, $sce, $state, $uibModal, Protocol, ProtocolService, SharedAgendaService, PaginationService, SharedAgendaBroadcast) {
        var vm = this;

        // overview service
        vm.overview = null;

        /* search user */
        vm.selectedUser = null;

        // show all
        vm.showAll = showAll;

        // start
        activate();

        /* new protocol */
        vm.new = function () {
            // modal 
            var modalInstance = null;

            // open modal
            modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                animation: true,
                templateUrl: '/app/settings/administration/modules/protocols/templates/protocol-details.template.html',
                controller: 'DetailProtocolController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    protocol: function () {
                        var protocol = new Protocol();

                        if (vm.selectedUser.id && vm.selectedUser.id > 0) {
                            // set user
                            protocol.fK_User = vm.selectedUser.id;
                            protocol.userDto = vm.selectedUser;
                        } else {
                            protocol.fK_User = SharedAgendaService.currentUser().id;
                            protocol.userDto = SharedAgendaService.currentUser();
                        }
                        return protocol;
                    },
                    protocolCategories: ['ProtocolCategoryService', function (ProtocolCategoryService) {
                        return ProtocolCategoryService.query(false);
                    }],
                    appointmentTypes: ['AppointmentTypeService', function (AppointmentTypeService) {
                        var userId = 0;

                        if (vm.selectedUser.id && vm.selectedUser.id > 0) {
                            userId = vm.selectedUser.id;
                        } else {
                            userId = SharedAgendaService.currentUser().id;
                        }

                        return AppointmentTypeService.queryByUserId(userId, false);
                    }]
                }
            });


            // when modal is closed
            modalInstance.result.then(function (item) {
                // push to array
                var protocol = new Protocol();
                protocol.extend(item);
                vm.overview.add(protocol);
            }, function () {
                //dismissed
            });
        };


        // reload view
        function showAll() {
            $state.go($state.current.name, { userId: vm.selectedUser ? vm.selectedUser.id : null, all: vm.overview.data.showAll }, { reload: $state.current.name });
        }

        // listen on changes
        function listen() {
            // listen on changed client
            var agendaListener = $scope.$on(SharedAgendaBroadcast.AgendaOwnerLoaded, function () {
                settings(SharedAgendaService.data.currentAgenda.owner);
            });

            // watcher for local selectedUser - check if changed
            var userChangeListener = $scope.$watch(function () {
                return vm.selectedUser;
            }, function (newVal, oldVal) {
                // is the same ?
                if (newVal === oldVal) {
                    return;
                }
                settings(newVal);
            });

            // on destroy
            $scope.$on("$destroy", function () {
                agendaListener();
                agendaListener = null;

                userChangeListener();
                userChangeListener = null;
            });
        } // listen

        // update view
        function settings(selectedUser) {

            vm.selectedUser = selectedUser;

            // check if user is selected
            if (vm.selectedUser) {
                // load from selected filter
                ProtocolService.query(vm.selectedUser.id, $state.params.all, null).then(function (result) {
                    vm.overview = new PaginationService(result);
                    vm.overview.data.items.forEach(protocol => {
                        setHtmlContent(protocol);
                    });
                });
            }
            else { // show no protocol -> user must be selected
                vm.overview = new PaginationService([]);
            }
        }

        function setHtmlContent(item)
        {
            if (item && item.content)
            {
                item.htmlContent = $sce.trustAsHtml(item.content);
            }
        }

        /* activation work */
        function activate() {

            // init overview Service
            settings(SharedAgendaService.data.currentAgenda.owner);

            // listen
            listen();

        } // activate
    }
})();
